import { render, staticRenderFns } from "./modal-edit-boards.vue?vue&type=template&id=22e0b9c8&"
import script from "./modal-edit-boards.vue?vue&type=script&lang=js&"
export * from "./modal-edit-boards.vue?vue&type=script&lang=js&"
import style0 from "./modal-edit-boards.vue?vue&type=style&index=0&id=22e0b9c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports